import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import update from 'immutability-helper';
import _get from 'lodash/get';

import Header from '../../../../components/Header';
import Text from '../../../../components/Text';
import Title from '../../../../components/Title';
import List from '../../../../components/List';
import Line from '../../../../components/Line';
import Actions from '../../../../components/Actions';
import SpecialList from '../../Components/SpecialList';
import Textarea from '../../../../components/Textarea';
import Tabs from '../../../../components/Tabs';
import TabsListItem from '../../../../components/TabsListItem';
import TabsList from '../../../../components/TabsList';
import CheckBox from '../../Components/CheckBox';
import TabsCut from '../../../../components/TabsCut';
import SvgIcon from '../../../../components/SvgIcon';
import MobileMenuHeader from '../../../../components/MobileMenuHeader';
import { bmcBlocksObject } from '../../../../utils/factories/bmcBlocks';

const icons = ['question', 'canvas'];
const iconsComponents = icons.map((e) => <SvgIcon name={e} />);

// todo: rewrite it
const CriticalAssumption = ({
  nextClickHandler,
  menuItems,
  selectComponent,
  componentIndex,
  rules,
  backPath,
  locales,
  locales: {
    common,
    testing: {
      caseStudies,
      name,
      assumption: { header, title, text, list, specialList, tabs },
    },
  },
}) => {
  const {
    testing: { test },
  } = useSelector((state) => state);

  const {
    testing: { updateTest },
  } = useDispatch();

  const blocks = _get(test, 'assumption.blocks', []);

  const onChange = (e) => {
    const updatedTest = {
      assumption: {
        ...test.assumption,
        text: e.target.value,
      },
    };
    updateTest({ id: test.id, test: updatedTest });
  };

  const onCheck = (e) => {
    // eslint-disable-next-line
    const { name, checked } = e.target;

    const operation = checked
      ? { $push: [name] }
      : {
          $splice: [[blocks.findIndex((i) => i === name), 1]],
        };
    const updatedTest = {
      assumption: {
        ...test.assumption,
        blocks: update(blocks, operation),
      },
    };

    updateTest({ id: test.id, test: updatedTest });
  };
  const [opened, setOpened] = useState(false);

  return (
    <div className="bmc-page testing">
      <Header
        className="bmc-page-header--blue"
        title={header}
        subtitle={name}
        icon="icon-VP"
        locales={locales}
        menuItems={menuItems}
        onMenuItemClick={selectComponent}
        componentIndex={componentIndex}
        mobileMenuHeader={
          <MobileMenuHeader icon="testingActive" title={name} color="blue" />
        }
        rules={rules}
        backPath={backPath}
      />
      <Text>{[text[0], text[1], text[2], text[3]]}</Text>

      <Title text={title[0]} align="left" />

      <Text>{[text[4], text[5], text[6]]}</Text>

      <SpecialList title={tabs.commonAssumptionsTitle} items={specialList} />

      <Title text={title[1]} align="left" />

      <List items={list} icons={icons} />

      <Line />

      <h2 className="bmc-page-title">
        <span className="bmc-page-title--blue">{title[2]}</span> {title[3]}
      </h2>

      <Text align="center">{[text[9]]}</Text>

      <Tabs
        tabs={[common.yourStrategy, common.caseStudy]}
        withBlur
        className="margin-top-60 bmc-page-tabs--blue"
      >
        {[
          <div key="strategy">
            <TabsList formStyle>
              <TabsListItem
                divider={false}
                className="mb-14"
                subtitle={tabs.whatYourAssumptionSub}
                title={tabs.whatYourAssumption}
                icon={iconsComponents[0]}
                text={
                  // eslint-disable-next-line
                  <>
                    <Textarea
                      value={_get(test, 'assumption.text', '')}
                      delay={300}
                      onChange={onChange}
                    />
                  </>
                }
              />
            </TabsList>
            <TabsList formStyle>
              <TabsListItem
                divider={false}
                subtitle={tabs.whatBmcBlocksDoesThisApplySub}
                title={tabs.whatBmcBlocksDoesThisApply}
                icon={iconsComponents[1]}
                text={
                  // eslint-disable-next-line
                  <div className="checkbox-wrapper">
                    <CheckBox
                      name="CS"
                      isChecked={blocks.includes('CS')}
                      onCheck={onCheck}
                      title={bmcBlocksObject.CS}
                    />

                    <CheckBox
                      name="VP"
                      isChecked={blocks.includes('VP')}
                      onCheck={onCheck}
                      title={bmcBlocksObject.VP}
                    />

                    <CheckBox
                      name="CH"
                      isChecked={blocks.includes('CH')}
                      onCheck={onCheck}
                      title={bmcBlocksObject.CH}
                    />

                    <CheckBox
                      name="CR"
                      isChecked={blocks.includes('CR')}
                      onCheck={onCheck}
                      title={bmcBlocksObject.CR}
                    />

                    <CheckBox
                      name="KA"
                      isChecked={blocks.includes('KA')}
                      onCheck={onCheck}
                      title={bmcBlocksObject.KA}
                    />

                    <CheckBox
                      name="KR"
                      isChecked={blocks.includes('KR')}
                      onCheck={onCheck}
                      title={bmcBlocksObject.KR}
                    />

                    <CheckBox
                      name="KP"
                      isChecked={blocks.includes('KP')}
                      onCheck={onCheck}
                      title={bmcBlocksObject.KP}
                    />

                    <CheckBox
                      name="CO"
                      isChecked={blocks.includes('CO')}
                      onCheck={onCheck}
                      title={bmcBlocksObject.CO}
                    />

                    <CheckBox
                      name="RE"
                      isChecked={blocks.includes('RE')}
                      onCheck={onCheck}
                      title={bmcBlocksObject.RE}
                    />

                    <CheckBox
                      name="SU"
                      isChecked={blocks.includes('SU')}
                      onCheck={onCheck}
                      title={bmcBlocksObject.SU}
                    />
                  </div>
                }
              />
            </TabsList>
          </div>,

          <Tabs
            key="tabs"
            tabs={caseStudies.map((e) => e.name)}
            className="bmc-page-tabs--black bmc-page-tabs--inner"
          >
            {caseStudies.map((item, index) => (
              <div key={index}>
                <TabsCut
                  setOpened={setOpened}
                  opened={opened}
                  caseStudy={item}
                />

                <TabsListItem
                  title={tabs.whatYourAssumption}
                  text={item.assumption.text}
                  icon={iconsComponents[0]}
                />
                <TabsListItem
                  divider={false}
                  title={tabs.whatBmcBlocksDoesThisApply}
                  icon={iconsComponents[1]}
                >
                  <div className="bmc-page-tabs-content-list-item-text">
                    <div className="checkbox-wrapper">
                      {item.assumption.blocks.map((block, i) => (
                        <CheckBox
                          isChecked
                          isPreview
                          key={i}
                          title={bmcBlocksObject[block]}
                        />
                      ))}
                    </div>
                  </div>
                </TabsListItem>
              </div>
            ))}
          </Tabs>,
        ]}
      </Tabs>

      <Actions nextClickHandler={nextClickHandler} buttonName={common.next} />
    </div>
  );
};

export default CriticalAssumption;
